export default {
  name: null,
  parent_id: null,
  status: 'inactive',
  static: {
    editable_pricings: false
  },
  room_types: []
}